import {Helmet} from "react-helmet";
import { useTranslation } from 'react-i18next';
import { Products } from 'components';
import { MainContact, Visual } from 'components/main';
import { H2 } from 'styles';
import React from "react";

export function Main(props) {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <meta name="keywords" content={t('meta.keywords.homepage')}/>
      </Helmet>
      <section>
        <H2 $display="none">main</H2>
        <Visual />
        <Products />
        <MainContact />
      </section>
    </>

  );
}
